import { useMemo } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectGates } from '../../../reducers/Portal';
// eslint-disable-next-line no-restricted-imports
import { isTrellisTheme, hasThemeDataAttribute } from 'foundations-theming/utils';
import { useTheme } from 'foundations-theming-specialty/utils';
export const useIsTrellisSwitcherEnabled = () => {
  const gates = useAppSelector(selectGates);
  const theme = useTheme();
  return useMemo(() => {
    const isTrellisUngated = gates && gates.includes('trellis:primary');
    const isTrellisAlwaysOnUngated = gates && gates.includes('trellis:always-on');

    // We don't want to show the switcher if the user is always on trellis.
    if (isTrellisAlwaysOnUngated) {
      return false;
    }

    // This does a few things beyond being a normal gate check:
    //
    // 1. Always show the switcher if the theme is the trellis theme so users don't
    // get stuck in the trellis theme.
    //
    // 2. If the user is ungated, but doesn't have the theme data attribute,
    // we don't show the switcher. This means that when we enable apps one at a
    // time the user will only see the switcher if the theme is enabled in that
    // app.
    return isTrellisUngated && hasThemeDataAttribute() || isTrellisTheme(theme);
  }, [gates, theme]);
};